import { SxProps } from '@mui/material'

interface CheckboxStyles {
  formControlLabel: SxProps
  labelWrapper: SxProps
  label: SxProps
  groupTitle: SxProps
}

export const checkboxStyles: CheckboxStyles = {
  formControlLabel: {
    ml: -1,
    gap: 0.5,
  },
  labelWrapper: {
    flex: 1,
  },
  label: {
    color: 'text.secondary700',
  },
  groupTitle: {
    color: 'text.primary900',
  },
}
